import benefitsDataGb from '../data/BenefitsData/benefitsDataGb';
import { LangData } from '../types/langTypes';

const gb: LangData = {
  id: '',
  name: '',
  images: [],
  altText: '',
  description: '',
  portfolioDescription1: "Responsive single- page website created for an ice - cream brand: features product showcase, how - it's-made section, gallery and contact form. Built with HTML, CSS (mobile-first) and JavaScript.",
  portfolioDescription2: "A modern responsive e-commerce web application built with clean UI/UX, featuring real-time product filtering, cart management and mobile-first layout. Technologies used: React, TypeScript, Redux and SCSS.",
  portfolioDescription3: "",
  portfolioDescription4: "",
  portfolioDescription5: "",
  portfolioDescription6: "",
  portfolioDescription: 'Portfolio description',
  backToTop: 'Back to top',
  mainNavigationLabel: "Main navigation",
  mainNavigation: ['Home', 'About', 'Services', 'Portfolio', 'Contact'],
  toggleMenu: "Toggle menu",
  logoTaglines: {
    top: "Think boldly",
    bottom: "Create wisely"
  },
  home: "Home",
  about: "About us",
  aboutmain: "About us",
  aboutTitle: "ABOUT US",
  aboutSubtitle: "Architects of Digital Superiority",
  aboutText: "SYDRIX is where high engineering aesthetics meet uncompromising business efficiency. Founded by a Ukrainian tech visionary in the heart of Bavaria, our studio has become synonymous with digital resilience and innovation. We don't just develop interfaces – we create digital assets that outperform the market. Our approach is built on three pillars: Performance-First (speed as a religion), Inclusive Design (accessibility as a standard), and Scalable Architecture (readiness for your business to grow tenfold). We believe that perfect code should be invisible, but the result must be tangible in every profit report. With SYDRIX, you get more than just a frontend; you get a technological edge that turns your brand into a leader of the digital era.",
  aboutPhilosophyTitle: "Our Philosophy",
  aboutPhilosophyText: "We replace outdated methods with a fresh perspective on performance. Our approach guarantees an architecture that won't need a rework in a year.",
  aboutButton: "Learn more",
  aboutButtonText: "View",
  aboutButtonLink: "/about",
  aboutImageAlt: "About us image",
  aboutList: ["Professional team", "Modern technologies", "Individual approach"],
  aboutQuote: "We love what we do!",
  aboutQuoteAuthor: "Team Founder",
  aboutStats: [
    { label: "Tech Stack", value: "Next.js" },
    { label: "Quality Focus", value: "100%" }
  ],
  aboutMission: "We transform complex technologies into your strategic assets, ensuring business leadership in the digital era.",
  aboutVision: "To become the global benchmark in frontend engineering, where every pixel works for the client's profit.",
  aboutValues: ["Engineering Excellence", "Radical Transparency", "Scalable Innovations"],
  aboutTeam: "Our team is our main asset.",
  aboutPartners: "Our partners trust us.",
  aboutClients: "Our clients are our friends.",
  aboutHistory: "The company's history began in 2025.",
  services: "Services",
  servicesTitle: "Our Services",
  servicesContactText: "Contact us for more details",
  servicesButton: "Learn More",
  servicesFormTitle: "Get a Free Consultation",
  servicesFormPlaceholder: "Your email",
  servicesFormButton: "Send",
  portfolio: "Portfolio",
  portfolioTitle: "Portfolio",
  portfolioText: "Ideas brought to life",
  portfolioLabel: "Portfolio",
  viewOnGithub: "View on GitHub",
  noProjectsFound: "No projects found.",

  testimonials: "Testimonials",
  testimonialsText: "We thank all our clients for their feedback!",
  blogTitle: "Blog",
  contacts: "Contacts",
  contactsTitle: "Contacts",
  phone: "Phone",
  email: "E-mail",
  faq: "FAQ",
  partnership: "Partnership",
  showAllButton: "Show All",
  showMoreButton: "Show More",
  hideAllButton: "Hide",
  title: "Frontend Development for Your Business",
  subtitle: [
    "Impressive Speed.",
    "Memorable Design.",
    "Captivating Experience."
  ],
  button: "Let’s Talk",
  benefitsTitle: "Benefits of Working with Us",
  benefitsSubtitle: "Why Clients Choose Us",
  benefitsText: "We build websites that are fast, secure, and efficient.",
  benefits: benefitsDataGb,
  goTo: "go to",
  footer: "Developed by Artem Sydorov",
  heroTitle: "Frontend Development for Your Business",
  heroSubtitle: [
    "Impressive Speed.",
    "Memorable Design.",
    "Captivating Experience."
  ],
  heroButton: "Let’s Talk",
  portfolioLink: "/portfolio",
  portfolioLinkText: "View Portfolio",

  serviceDetailsTitle: "Service Details",
  serviceDetailsText: "Detailed information about our services.",
  servicesDetailsButton: "Learn More About the Service",
  servicesDetailsSubtitle: "More About Our Services",
  servicesDetailsList: ["Service 1", "Service 2", "Service 3"],
  showLessButton: "Show Less",

  notFoundTitle: "Page Not Found",
  notFoundText: "Sorry, this page doesn't exist.",
  notFoundButton: "Back to Home",
  cookieConsentText: "This website uses cookies to improve your experience.",
  cookieConsentButton: "Got it",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  loading: "Loading...",
  error: "An error occurred. Please try again.",
  success: "Success!",
  language: "Language",
  selectLanguage: "Choose a language",
  close: "Close",

  serviceDetailsBack: "Back to Services",
  faqTitle: "Frequently Asked Questions",
  faqSubtitle: "Answers to Common Questions",
  faqText: "If you have questions, check this section or contact us.",
  team: "Team",
  teamTitle: "Our Team",
  teamText: "We’re a team of professionals who love what we do.",
  process: "Process",
  processTitle: "How We Work",
  processText: "We follow a transparent development process.",
  technologies: "Technologies",
  technologiesTitle: "Technologies We Use",
  technologiesText: "We use modern frameworks and tools.",
  price: "Price",
  priceTitle: "Service Pricing",
  priceText: "Learn more about our pricing.",

  processSubtitle: "Our Work Stages",
  teamSubtitle: "Meet Our Team",
  teamButton: "Learn More About the Team",
  teamButtonText: "View Team",
  processButton: "Learn About the Process",
  processButtonText: "View Process",
  technologiesSubtitle: "Our Technologies",
  technologiesButton: "Learn More About Technologies",
  technologiesButtonText: "View Technologies",
  priceSubtitle: "Pricing Details",
  priceButton: "Learn More About Pricing",
  priceButtonText: "View Prices",

  teamButtonLink: "/team",
  portfolioButton: "Learn More About Portfolio",
  portfolioButtonText: "View Portfolio",
  portfolioButtonLink: "/portfolio",
  blogButton: "Learn More About the Blog",
  blogButtonText: "View Blog",
  blogButtonLink: "/blog",
  contactsButton: "Learn More About Contacts",
  contactsButtonText: "View Contacts",
  contactsButtonLink: "/contacts",
  faqButton: "Learn More About FAQ",
  faqButtonText: "View FAQ",
  faqButtonLink: "/faq",
  notFoundButtonText: "Return to Home",
  cookieConsentMore: "More Info",
  privacyPolicyButton: "View Policy",
  termsOfServiceButton: "View Terms",

  contactsButtonLinkText: "Go to Contacts",
  cookieConsentLink: "/privacy-policy",
  privacyPolicyButtonText: "View Privacy Policy",
  termsOfServiceButtonText: "View Terms of Service",
  aboutButtonLinkText: "More About Us",
  servicesButtonLinkText: "More About Services",
  portfolioButtonLinkText: "More About Portfolio",
  blogButtonLinkText: "More About Blog",
  faqButtonLinkText: "More About FAQ",
  teamButtonLinkText: "More About Team",
  processButtonLinkText: "More About Process",
  technologiesButtonLinkText: "More About Technologies",
  priceButtonLinkText: "More About Prices",
  notFoundButtonLinkText: "Return to Home",
  cookieConsentButtonText: "Got it",
  cookieConsentMoreText: "More Info",


  faqQuestion: "Question",
  faqAnswer: "Answer",
  priceButtonLink: "/price",
  processButtonLink: "/process",
  technologiesButtonLink: "/technologies",
  servicesButtonLink: "/services",
  notFoundButtonLink: "/",
  privacyPolicyLink: "/privacy-policy",
  termsOfServiceLink: "/terms-of-service",

  partnershipTitle: "Partnership",
  partnershipSubtitle: "Collaboration Opportunities",
  partnershipText: "We are open to partnerships and new collaboration opportunities.",
  notFoundBackButton: "Go Back",
  extraField1: "Extra Field 1",
  extraField2: "Extra Field 2",

  notFoundLink: "/",
  cookieConsent: "This website uses cookies to improve your experience.",
  noPortfolioItems: 'Portfolio is currently empty',
  noImages: 'No images available',

  "impressum.back": "Back",
  "impressum.subtitle": "Legal Notice",
  "impressum.infoTitle": "Information according to § 5 TMG",
  "impressum.owner": "Owner",
  "impressum.address": "Hochriesstraße 29",
  "impressum.city": "83209 Prien am Chiemsee, Germany",
  "impressum.contactTitle": "Contact",
  "impressum.email": "Email",
  "impressum.website": "Website",
  "impressum.copyrightTitle": "Copyright Notice",
  "impressum.rights": "All rights reserved.",
  "impressum.disputeTitle": "Dispute Resolution",
  "impressum.disputeText": "The European Commission provides a platform for online dispute resolution (OS):",
  "impressum.disputeFinal": "I am not obliged to participate in dispute resolution proceedings before an arbitration board.",
  "impressum.disclaimerTitle": "Legal Disclaimer",
  "impressum.disclaimerText": "Liability for Content: The contents of our pages were created with great care. However, we cannot guarantee the accuracy, completeness, or timeliness of the content. As a service provider, we are responsible for our own content on these pages in accordance with general laws. Liability for Links: Our site contains links to external third-party websites, over whose content we have no influence. Therefore, we cannot accept any liability for this external content.",
  "impressum.taxStatus": "According to § 19 UStG, no VAT is charged (Small Business Status).",
  "impressum.responsible": "Responsible for content according to § 18 MStV",
  "impressum.phone": "Phone",
  "impressum.copyrightText": "The content and works created by the site operator on these pages are subject to copyright law. Duplication, processing, distribution, or any form of use beyond the scope of copyright law requires the prior written consent of the author.",
  "impressum.copyrightLinkText": "German Copyright Act (UrhG)",

  "privacy.title": "Privacy Policy",
  "privacy.intro": "I take the protection of your personal data very seriously. This website is designed to process as little data as possible.",
  "privacy.hostingTitle": "1. External Hosting",
  "privacy.hostingText": "This website is hosted by an external service provider (hoster). The personal data collected on this website is stored on the hoster's servers. This primarily includes IP addresses and metadata. The use of the hoster is in the interest of a secure and fast provision of our online service by a professional provider (Art. 6 Para. 1 lit. f GDPR).",
  "privacy.dataTitle": "2. Data Minimization",
  "privacy.dataText": "In the spirit of data minimization, this site refrains from using cookies, analysis tools (tracking), and contact forms. No evaluation of your user behavior takes place.",
  "privacy.rightsTitle": "3. Rights of the Data Subject",
  "privacy.rightsText": "Under the applicable legal provisions, you have the right at any time to free information about your stored personal data, as well as a right to correction or deletion of this data.",
  "privacy.contactTitle": "4. Responsible Party",
  "privacy.contactText": "The party responsible for data processing is Artem Sydorov. Full contact details can be found in the Impressum of this site.",
}

export default gb;
